export default __webpack_public_path__ + "6209654339681fabdfc9a5767478d2cd.png";